import { LoginData } from "./LoginDataInterface";

const loginInfo: LoginData[] = [];
loginInfo.push({
	userName: "username",
	password: "password",
});
loginInfo.push({
	userName: "username1",
	password: "password1",
});
export default loginInfo;
